import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';

interface Props {
  onClick: () => void;
  label: string;
}

export const ImageLabelOverlay: FC<Props> = ({onClick, label}) => {
  const handleOverlayClick: React.MouseEventHandler = event => {
    event.preventDefault();
    event.stopPropagation();

    onClick();
  };
  return (
    <LabelContainer onClick={handleOverlayClick}>
      <StyledSpan>{label}</StyledSpan>
    </LabelContainer>
  );
};

const LabelContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.2);
  height: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

const StyledSpan = styled.span`
  border-bottom: 1.5px solid ${COLORS.White};
  color: ${COLORS.White};
  font-size: 16px;
  left: 50%;
  padding-bottom: 4px;
  position: absolute;
  top: 50%;
  transform: translate(-50%);
`;
